import React, { Component, PropTypes } from 'react';
import { Icon, Button, Modal, Spin, Select, Radio, Row, Col, Form, Input, Upload, Checkbox, InputNumber, DatePicker } from 'antd';

import { browserHistory } from 'react-router';
import uuidV4 from 'uuid/v4';
import { loadImageWithOrientation } from 'utils/getBase64Img';
import _ from 'lodash';
import moment from 'moment';
import config from 'config';
import Draft from 'draft-js';
import cn from 'classnames';
import { getBase64, stripBase64FileType } from 'utils/getBase64Img';
import request from 'superagent';
// import MediaQuery from 'react-responsive';
// import { convertToRaw } from 'draft-js';
import { formItemLayout, fullFormLayout } from 'constants/layout';

import { connect } from 'react-redux';
import { getCategories } from 'redux/modules/category';
import Utils from 'utils/utils';
import Editor from 'components/Form/WYSIWYG';
import CustomInput from 'components/Form/Input';
import Slider from 'components/Slider/Slider';

import { rejectClassroom, approveClassroom, updateClassById } from 'data/class';
import { formatNumber } from 'utils/formatting';
import Dropzone from 'react-dropzone';

import classes from '../styles/class/ClassInfo.module.scss';

// const SubMenu = Menu.SubMenu;
// const MenuItemGroup = Menu.ItemGroup;
const FormItem = Form.Item;
const { Option, OptGroup } = Select;
const { TextArea } = Input;
const RadioGroup = Radio.Group;

const classTypes = {
  single: 'เรียนครั้งเดียวจบ',
  multiple: 'เรียนหลายครั้ง',
  timetable: 'ผู้เรียนเลือกวันได้',
};

class ClassInfoTab extends Component {
  constructor(props) {
    super(props);
    this.onEditorStateChange = this.onEditorStateChange.bind(this);

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleReject = this.handleReject.bind(this);
    this.handleApprove = this.handleApprove.bind(this);

    this.toggleRejectModal = this.toggleRejectModal.bind(this);

    this.state = {
      collapseMobile: [],
      mode: 'editor',
      currentRevision: null,
      showRejectModal: false,
      // fullDescriptionEditorState,
      // timetableEditorState,
      // preparingBeforeClassEditorState,
      // suitableForEditorState,
      // courseCoveringEditorState,

      // rejectMessageEditorState,
      isPreview: true,
      isImageLoading: false,
      mouseHoverStatus: [false, false, false, false],
      alreadyUploadImage: false,
      images: [],
      loading: false,
      // files,
    };
  }

  componentDidMount = () => {
    const allSubcategories = this.props.categories.reduce((result, cat) => _.concat(result, cat.subcategories), []);
    this.setState({
      allSubcategories,
    });
  };

  onEditorStateChange(editorState, key) {
    this.setState({
      [key]: editorState,
    });
  }

  mouseEnterImage(i) {
    this.state.mouseHoverStatus[i] = true;
    this.setState({ mouseHoverStatus: this.state.mouseHoverStatus });
  }

  mouseExitImage(i) {
    this.state.mouseHoverStatus[i] = false;
    this.setState({ mouseHoverStatus: this.state.mouseHoverStatus });
  }

  toggleRejectModal() {
    console.log('toggle', !this.state.showRejectModal);
    this.setState({
      showRejectModal: !this.state.showRejectModal,
    });
  }

  handleApprove(e) {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll(['subcategories'], (err, values) => {
      if (!err) {
        values.subcategories = values.subcategories.map((subcat) => subcat.key);
        approveClassroom(this.props.classroom._id, values).then(() => {
          this.props.getClassById(this.props.classroom._id);
        });
      }
    });
  }

  handleSubmit(e) {
    e.preventDefault();

    this.props.form.validateFieldsAndScroll((err, values) => {
      console.log('Received values of form: ', values);
      if (!err) {
        this.setState({ loading: true });
        const newClass = _.merge(values, {});
        if (values.classType !== 'timetable') {
          newClass.isPrivate = false;
        }
        if (!newClass.isDiscount) {
          delete newClass.discountExpiredDate;
          delete newClass.discountPrice;
        }
        if (this.state.images && this.state.images.length > 0) {
          newClass.images = this.state.images.map((image) => image.url);
        }
        if (this.state.uploadedCoverImageUrl) {
          newClass.coverImage = stripBase64FileType(this.state.uploadedCoverImageUrl);
        }
        updateClassById(this.props.classroom._id, newClass).then(() => {
          this.props.getClassById(this.props.classroom._id);
          this.setState({ isPreview: true, loading: false });
        });

        console.log('Received values of form: ', values);
      }
    });
  }
  handleReject(e) {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll(['rejectMessage'], (err, values) => {
      if (!err) {
        rejectClassroom(this.props.classroom._id, {
          rejectMessage: values.rejectMessage,
        }).then(() => {
          this.props.getClassById(this.props.classroom._id);
          this.setState({ showRejectModal: false });
        });
        console.log('Received values of form: ', values);
      }
    });
  }

  renderHistoryData(current, revision, field) {
    if (!revision) {
      return <div />;
    }
    const currentData = _.get(current, field);
    const historyData = _.get(revision, field);
    if (currentData === historyData) {
      return <div />;
    }
    return (
      <div className={cn('red', classes.changed)}>
        <div dangerouslySetInnerHTML={{ __html: historyData }} />
      </div>
    );
  }

  renderPreviewItem(title, value, isBlockContent) {
    let contentSize = 18;
    let titleSize = 6;
    if (isBlockContent) {
      contentSize = 24;
      titleSize = 24;
    }
    return (
      <Row className={'ant-form-item'}>
        <Col className={cn('form-preview-title bold', { 'text-left': isBlockContent })} sm={titleSize}>
          <label>{title}</label>
        </Col>
        <Col className={cn('form-preview-content')} sm={contentSize}>
          <div dangerouslySetInnerHTML={{ __html: value }} />
        </Col>
      </Row>
    );
  }

  renderPreviewMode() {
    const { getFieldDecorator } = this.props.form;
    const { classroom } = this.props;
    const subcats = classroom.subcategories.map((subcat) => ({
      key: subcat._id,
      label: subcat.name,
    }));
    const cats = this.props.categories;
    const isShowHistoryData = this.state.currentRevision !== null;
    const province = _.find(this.props.provinces, { value: classroom.province });

    const allTags = _.map(this.props.tags, (tag) => tag.value);
    const selectedTags = classroom.tags.map((tag) => ({
      key: tag,
      label: tag,
    }));

    return (
      <div>
        {!isShowHistoryData && (
          <div className={'text-right '}>
            <span
              className={'pointer'}
              onClick={() => {
                this.setState({ loading: true });
                setTimeout(() => {
                  this.setState({ isPreview: false, alreadyUploadImage: false, loading: false });
                }, 1);
              }}
            >
              <Icon type="edit" /> Edit
            </span>
          </div>
        )}
        {this.renderPreviewItem('ประเภท Class เรียน: ', `${classTypes[classroom.classType]}${classroom.classType === 'multiple' ? ` (${classroom.studiedCount} ครั้ง)` : ''}`)}

        {classroom.classType === 'timetable' && this.renderPreviewItem('รูปแบบ Class เรียน: ', `${classroom.isPrivate ? `คลาสส่วนตัว / กลุ่มส่วนตัว` : `คลาสกลุ่ม`}`)}

        {this.renderPreviewItem('ชื่อ Class: ', classroom.name)}
        {this.renderHistoryData(classroom, this.state.currentRevision, 'name')}

        {this.renderPreviewItem('อธิบายเกี่ยวกับคลาสนี้สั้นๆ: ', classroom.shortDescription, true)}
        {this.renderHistoryData(classroom, this.state.currentRevision, 'shortDescription')}

        {this.renderPreviewItem('สถานที่: ', `${_.get(province, 'label')}`, true)}
        {this.renderHistoryData(classroom, this.state.currentRevision, 'province')}

        {this.renderPreviewItem('รายละเอียด Class: ', classroom.fullDescription, true)}
        {this.renderHistoryData(classroom, this.state.currentRevision, 'fullDescription')}

        {this.renderPreviewItem('ตารางเรียน / กำหนดการ: ', classroom.timetable, true)}
        {this.renderHistoryData(classroom, this.state.currentRevision, 'timetable')}

        {this.renderPreviewItem('สิ่งที่ต้องเตรียมมา: ', classroom.preparingBeforeClass, true)}
        {this.renderHistoryData(classroom, this.state.currentRevision, 'preparingBeforeClass')}

        {this.renderPreviewItem('Class เรียนนี้เหมาะกับใคร: ', classroom.suitableFor, true)}
        {this.renderHistoryData(classroom, this.state.currentRevision, 'suitableFor')}

        {this.renderPreviewItem('ค่าเรียนนี้รวม: ', classroom.courseCovering, true)}
        {this.renderHistoryData(classroom, this.state.currentRevision, 'courseCovering')}

        {this.renderPreviewItem('ราคา: ', classroom.price)}
        {this.renderHistoryData(classroom, this.state.currentRevision, 'price')}

        {this.renderPreviewItem('ผลงานผู้เรียน: ', classroom.studentWorkLink)}
        {this.renderHistoryData(classroom, this.state.currentRevision, 'studentWorkLink')}

        <Form onSubmit={this.handleSubmit}>
          <FormItem {...formItemLayout} hasFeedback label="หมวดหมู่ย่อย">
            {getFieldDecorator('subcategories', {
              rules: [
                {
                  required: true,
                  message: 'Please input หมวดหมู่ย่อย',
                },
              ],
              initialValue: subcats,
            })(
              <Select
                mode="multiple"
                // style={{ width: '100%' }}
                labelInValue
                searchPlaceholder="Subcategories"
                onChange={this.handleChange}
              >
                {cats.map((cat, i) => (
                  <OptGroup key={cat.name} label={cat.name}>
                    {cat.subcategories.map((subcat) => (
                      <Option key={subcat._id}>{subcat.name}</Option>
                    ))}
                  </OptGroup>
                ))}
              </Select>,
            )}
          </FormItem>

          <FormItem {...formItemLayout} hasFeedback label="tags">
            {getFieldDecorator('tags', {
              rules: [],
              initialValue: selectedTags,
            })(
              <Select
                mode="multiple"
                // style={{ width: '100%' }}
                labelInValue
                searchPlaceholder="tags"
                onChange={this.handleChange}
              >
                {allTags.map((tag) => (
                  <Option key={tag}>{tag}</Option>
                ))}
              </Select>,
            )}
          </FormItem>

          <div className={cn(classes.btnContainer, 'text-center')}>
            <Button type="danger" size="large" onClick={this.toggleRejectModal} loading={this.state.loading}>
              Reject
            </Button>
            <Button
              type="success"
              size="large"
              disabled={!classroom.owner.verified || !classroom.owner.user.verifiedEmail}
              onClick={classroom.owner.verified && classroom.owner.user.verifiedEmail && this.handleApprove}
              loading={this.state.loading}
            >
              Approve
            </Button>
          </div>
        </Form>
      </div>
    );
  }

  handleUploadImage = (info) => {
    if (info.file.status === 'uploading') {
      this.setState({ loading: true });
      return;
    }
    if (info.file.status === 'done') {
      // console.log(info.file);
      // console.log(info.file.response.imageUrl);

      if (info.type === 'images') {
        const images = [...this.state.images, info.file.response.imageUrl];
        this.setState({
          images,
          loading: false,
        });
      } else {
        this.setState({
          [info.name]: info.file.response.imageUrl,
          loading: false,
        });
      }
    }
  };

  handleUploadImages = (info) => {
    const fileList = info.fileList.map((file) => {
      if (file.response && file.response.imageUrl) {
        file.url = file.response.imageUrl;
      }
      return file;
    });
    this.setState({ images: fileList, alreadyUploadImage: true });
  };
  customRequest = ({ action, file, onProgress, onSuccess, onError }) => {
    getBase64(file, (imageBase64) => {
      request
        .post(action, { imageReferenceId: uuidV4(), image: stripBase64FileType(imageBase64) })
        .on('progress', onProgress)
        .then((response) => {
          onSuccess(response.body);
        }, onError);
    });

    return {};
  };
  handlePreview = async () => {};

  renderImagesForm() {
    // return <div />;
    // const imageUrl = this.state.uploadedImageUrl ? this.state.uploadedImageUrl : _.get(this.props, 'order.paymentDetail.evidence');
    let fileList = [];
    if (_.get(this.props, 'classroom.images')) {
      fileList = this.props.classroom.images.map((image, index) => {
        return {
          uid: index,
          name: `image-${index}`,
          url: image,
          status: 'done',
        };
      });
    }

    if (this.state.images && this.state.alreadyUploadImage) {
      fileList = this.state.images;
    }

    const uploadButton = (
      <div>
        <Icon type={this.state.loading ? 'loading' : 'plus'} />
        <div className="ant-upload-text">Upload</div>
      </div>
    );

    return (
      <Upload
        className="avatar-uploader"
        listType="picture-card"
        action={`${config.apiHost}/classes/images`}
        fileList={fileList}
        beforeUpload={this.beforeUpload}
        customRequest={this.customRequest}
        onChange={(info) => this.handleUploadImages({ ...info, name: 'imageNumber', type: 'images', index: fileList.length })}
      >
        {uploadButton}
        {
          // fileList.length >= 3 ? null : uploadButton
        }
      </Upload>
    );
  }

  renderCoverImageForm() {
    // return <div />;
    const imageUrl = this.state.uploadedCoverImageUrl ? this.state.uploadedCoverImageUrl : _.get(this.props, 'classroom.coverImage');
    const uploadButton = (
      <div>
        <Icon type={this.state.loading ? 'loading' : 'plus'} />
        <div className="ant-upload-text">Upload</div>
      </div>
    );

    return (
      <Upload
        name="avatar"
        listType="picture-card"
        className="avatar-uploader"
        action={`${config.apiHost}/classes/images`}
        // action="http://localhost:8020/classes/images"
        showUploadList={false}
        beforeUpload={this.beforeUpload}
        customRequest={this.customRequest}
        onChange={(info) => this.handleUploadImage({ ...info, name: 'uploadedCoverImageUrl' })}
      >
        {imageUrl ? <img src={imageUrl} alt="avatar" /> : uploadButton}
      </Upload>
    );
  }

  renderEditorMode() {
    const { getFieldDecorator, getFieldsValue, getFieldValue } = this.props.form;
    const { classroom } = this.props;

    const subcats = classroom.subcategories.map((subcat) => ({
      key: subcat._id,
      label: subcat.name,
    }));
    const selectedSubcat = subcats.reduce((result, subcat) => {
      if (result === '') {
        return subcat.label;
      }
      return `${result}, ${subcat.label}`;
    }, '');
    let scheduleCount = 0;
    if (classroom.passSchedules && classroom.upcomingSchedules) {
      scheduleCount = classroom.passSchedules.length + classroom.upcomingSchedules.length;
    }

    return (
      <div className={classes.classEditorContainer}>
        <div className={'text-right pointer red'} onClick={() => this.setState({ isPreview: true })}>
          <Icon type="close" /> Cancel Edit
        </div>
        {this.renderCoverImageForm()}
        {this.renderImagesForm()}

        {this.renderPreviewItem('หมวดหมู่ย่อย: ', selectedSubcat === '' ? 'ยังไม่ได้เลือก' : selectedSubcat)}
        {/* {this.renderPreviewItem('ประเภทคลาสเรียน: ', classTypes[classroom.classType])} */}
        <Form onSubmit={this.handleSubmit}>
          <FormItem {...formItemLayout} className={'input-withcounter'} hasFeedback label="ประเภท Class เรียน">
            {getFieldDecorator('classType', {
              rules: [
                {
                  required: true,
                  message: 'Please input ประเภท Class เรียน',
                },
              ],
              initialValue: classroom.classType,
            })(
              <RadioGroup onChange={this.onChange}>
                <Radio value={'single'}>เรียนครั้งเดียวจบ</Radio>
                <Radio value={'multiple'}>เรียนหลายครั้ง</Radio>
                <Radio value={'timetable'}>ผู้เรียนเลือกวันได้</Radio>
              </RadioGroup>,
            )}
          </FormItem>

          {getFieldsValue(['classType']).classType === 'timetable' && (
            <FormItem {...formItemLayout} className={'input-withcounter'} hasFeedback label="รูปแบบ Class เรียน:">
              {getFieldDecorator('isPrivate', {
                rules: [
                  {
                    required: true,
                    message: 'Please input รูปแบบ Class เรียน',
                  },
                ],
                initialValue: classroom.isPrivate,
              })(
                <RadioGroup onChange={this.onChange}>
                  <Radio value={false}>คลาสกลุ่ม</Radio>
                  <Radio value={true}>คลาสส่วนตัว / กลุ่มส่วนตัว</Radio>
                </RadioGroup>,
              )}
            </FormItem>
          )}

          {/* <label></label>
                <RadioGroup selectedValue={savedClass.isPrivate} onChange={(value) => handleClassChange({ target: { name: 'isPrivate', value } })}>
                  <div className="row">
                    <div className={cn('col-md-4', styles.radioContainer)}>
                      <label className={cn('radio-inline', 'custom-radio-container')}>
                        <RadioButton value={false} className={cn('custom-radio', {})} useHiddenInput={true}>
                          <i className={cn('tp-icon-mark')} />
                        </RadioButton>
                        <lable></lable>
                      </label>
                    </div>
                    <div className={cn('col-md-4', styles.radioContainer)}>
                      <label className={cn('radio-inline', 'custom-radio-container')}>
                        <RadioButton value={true} className={cn('custom-radio', {})} useHiddenInput={true}>
                          <i className={cn('tp-icon-mark')} />
                        </RadioButton>
                        <lable></lable>
                      </label>
                    </div>
                  </div>
                </RadioGroup> */}

          {getFieldsValue(['classType']).classType === 'multiple' && scheduleCount === 0 && (
            <FormItem {...formItemLayout} hasFeedback label="จำนวนครั้ง">
              {getFieldDecorator('studiedCount', {
                rules: [
                  {
                    required: true,
                    message: 'Please input จำนวนครั้ง',
                  },
                ],
                initialValue: classroom.studiedCount,
              })(<Input />)}
            </FormItem>
          )}

          <FormItem {...formItemLayout} className={'input-withcounter'} hasFeedback label="ชื่อคลาส">
            {getFieldDecorator('name', {
              rules: [
                {
                  required: true,
                  message: 'Please input Title',
                },
              ],
              initialValue: classroom.name,
            })(
              <CustomInput
                placeholder="Class name"
                initValue={classroom.name} //
                showCounter={true}
                limit={80}
                maxLength={80}
              />,
            )}
          </FormItem>

          <FormItem {...formItemLayout} label="อธิบายเกี่ยวกับคลาสนี้สั้นๆ">
            {getFieldDecorator('shortDescription', {
              initialValue: classroom.shortDescription,
            })(<CustomInput initValue={classroom.shortDescription} showCounter={true} limit={200} />)}
          </FormItem>

          <FormItem {...formItemLayout} label="สถานที่">
            {getFieldDecorator('province', {
              initialValue: classroom.province,
            })(
              <Select
                // style={{ width: '100%' }}
                // labelInValue
                searchPlaceholder="province"
                // defaultValue={classroom.province || 'others'}
                onChange={this.handleChange}
              >
                {this.props.provinces.map((province) => (
                  <Option key={province.value} value={province.value}>
                    {province.label}
                  </Option>
                ))}
              </Select>,
            )}
          </FormItem>

          <FormItem {...formItemLayout} label="รายละเอียด Class">
            {getFieldDecorator('fullDescription', {
              initialValue: classroom.fullDescription,
            })(<Editor data={classroom.fullDescription} limit={10000} />)}
          </FormItem>

          <FormItem {...formItemLayout} label="ตารางเรียน / กำหนดการ">
            {getFieldDecorator('timetable', {
              initialValue: classroom.timetable,
            })(<Editor data={classroom.timetable} limit={1500} />)}
          </FormItem>
          <FormItem {...formItemLayout} label="สิ่งที่ต้องเตรียมมา">
            {getFieldDecorator('preparingBeforeClass', {
              initialValue: classroom.preparingBeforeClass,
            })(<Editor data={classroom.preparingBeforeClass} limit={500} />)}
          </FormItem>
          <FormItem {...formItemLayout} label="Class เรียนนี้เหมาะกับใคร">
            {getFieldDecorator('suitableFor', {
              initialValue: classroom.suitableFor,
            })(<Editor data={classroom.suitableFor} limit={1000} />)}
          </FormItem>
          <FormItem {...formItemLayout} label="ค่าเรียนนี้รวม">
            {getFieldDecorator('courseCovering', {
              initialValue: classroom.courseCovering,
            })(<Editor data={classroom.courseCovering} limit={1000} />)}
          </FormItem>

          <FormItem {...formItemLayout} hasFeedback label="ราคา">
            {getFieldDecorator('price', {
              rules: [
                {
                  required: true,
                  message: 'Please input ราคาปกติ',
                },
              ],
              initialValue: classroom.price,
            })(<InputNumber />)}
          </FormItem>
          <FormItem {...formItemLayout} label="ผลงานนักเรียน">
            {getFieldDecorator('studentWorkLink', {
              initialValue: classroom.studentWorkLink,
            })(<Input placeholder="ผลงานนักเรียน" />)}
          </FormItem>

          <FormItem {...formItemLayout} label="Remark">
            {getFieldDecorator('remark', {
              initialValue: classroom.remark,
            })(<TextArea placeholder="Remark" />)}
          </FormItem>

          <div className={cn(classes.btnContainer, 'text-center')}>
            <Button type="primary" size="large" onClick={this.handleSubmit} loading={this.state.loading}>
              Save
            </Button>
            <Button type="danger" size="large" onClick={() => this.setState({ isPreview: true })}>
              Cancel
            </Button>
          </div>
        </Form>
      </div>
    );
  }

  renderRejectModal() {
    if (!this.state.showRejectModal) {
      return <div />;
    }
    const { getFieldDecorator } = this.props.form;
    return (
      <Modal
        title="Reject Reason"
        visible={this.state.showRejectModal}
        onCancel={this.toggleRejectModal}
        footer={
          <div>
            <Button type="danger" size="large" onClick={this.handleReject} loading={this.state.loading}>
              Confirm Reject
            </Button>
          </div>
        }
      >
        <Form onSubmit={this.handleReject}>
          <FormItem {...fullFormLayout} hasFeedback>
            {getFieldDecorator('rejectMessage', {
              rules: [
                {
                  required: true,
                  message: 'Please input เหตุผลที่ปฏิเสธ',
                },
              ],
            })(<Editor initValue={this.state.rejectMessage} hideCounter={true} />)}
          </FormItem>
        </Form>
      </Modal>
    );
  }

  renderRevision() {
    const { classroom, classRevisions } = this.props;
    const sliderSettings = {
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      dotsClass: cn('slick-dots', classes.dots),
      adaptiveHeight: true,
      arrows: false,
      autoplay: false,
    };
    const imageSrcs = [classroom.coverImage].concat(classroom.images);

    return (
      <div>
        <div className={cn('content')}>
          <Slider {...sliderSettings} images={imageSrcs} />
        </div>

        <div className={cn('content')}>
          <span>Info updates</span>
          <hr />
          <div>
            {_.get(this.state, 'currentRevision') === null && <span>{'> '}</span>}
            <a onClick={() => this.setState({ currentRevision: null })}>Current</a>
          </div>

          <hr />
          {classRevisions.map((cr, i) => {
            return (
              <div key={i}>
                {_.get(this.state, 'currentRevision.createdAt') === _.get(cr, 'createdAt') && <span>{'> '}</span>}
                <a onClick={() => this.setState({ currentRevision: cr })}>{moment(cr.createdAt).format('DD/MM/YY HH:mm:ss')}</a>
                <hr />
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  render() {
    // console.log(this.state.files);
    const { loading } = this.state;

    return (
      <div>
        {this.renderRejectModal()}
        <Spin tip="Loading" size="large" spinning={!!loading}>
          <Row className="">
            {this.state.isPreview && (
              <Col xs={18} span={18} className="with-padding-right">
                <div className={cn('content')}>{this.renderPreviewMode()}</div>
              </Col>
            )}
            {!this.state.isPreview && (
              <Col xs={24} span={24} className="with-padding-right">
                <div className={cn('content')}>{this.renderEditorMode()}</div>
              </Col>
            )}
            {this.state.isPreview && (
              <Col xs={6} span={6} className="with-padding-right">
                <div>{this.renderRevision()}</div>
              </Col>
            )}
          </Row>
        </Spin>
      </div>
    );
  }
}
export default connect(
  (state) => ({
    // pages: state.content.pages,
  }),
  { rejectClassroom, approveClassroom, updateClassById },
)(Form.create()(ClassInfoTab));
